/*global define */
/*jshint devel:true*/
/**
 * BaseCollection class
 * @depends on BaseModel class, but not written here to avoid circular dependency issues
 * This class has to be used only when BaseModel is already defined
 */
define(
	'BaseCollection',[
		'underscore',
		'require',
		'backbone',
		'BaseClassGenerator',
		'BaseModel'
	],
	function (_, require, Backbone, BaseClassGenerator, BaseModel) {
		'use strict';

		var ParentClass = Backbone.Collection;

		/**
		 * @class
		 * @name BaseCollection
		 * @extends Backbone.Collection
		 */
		var BaseCollection = BaseClassGenerator.generate(ParentClass,
			/**
			 * @lends BaseCollection.prototype
			 */
			{ // base model definition
				className: 'BaseCollection',

				model: BaseModel,

//				/**
//				 * DEBUG
//				 */
//				initialize: function() {
//					// DEBUG
//					// report all events
//					this.on('all', function(){
//						console.warn(this, arguments);
//					});
//					ParentClass.prototype.initialize.apply(this, arguments);
//				},

				/**
				 * Validates all models contained in the collection.
				 *
				 * @return {Array|undefined} Returns a list of validation results for each models of the collection. If there hasn't been any error, then it returns is undefined.
				 * Format of one item of the returned array:
				 * {
				 *  index: 0,
				 *  model: Backbone_Model_instance,
				 *  error: "error returned by model.validate()"
				 * }
				 */
				nestedValidate: function (options) {
					var self = this,
						methodName = 'nestedValidate',
						errorList = [];

					//DEBUG
					//console.log(self.report(methodName, ' this=%o args=%o'), self, arguments);

					self.each(function (model, index) {
						var isError;

						if (model instanceof BaseModel) {
							isError = model.nestedValidate(options);
						} else {
							isError = model.validate({}, options); // may break if the model does not support validate()
						}

						//DEBUG
						//console.log(self.report(methodName, '[%o] = %o: %o'), index, model, isError);

						if (isError) {
							errorList.push({
								index: index,
								model: model,
								error: isError
							});
						}
					});

					if (!errorList.length) {
						errorList = undefined;
					}
					self.nestedValidationError = errorList;
					return errorList;
				},

				/**
				 * Does not validate a collection like this.
				 * It's necessary to have this when we have a collection of collections in Backbone.
				 * @private
				 */
				_validate: function() {
//					var self = this;
//					self.nestedValidate.apply(self, arguments);
				},

				/**
				 * Does not validate a collection like this.
				 * It's necessary to have this when we have a collection of collections in Backbone.
				 * @private
				 */
				//_validate: function() {
//					var self = this;
//					self.nestedValidate.apply(self, arguments);
				//},

				/**
				 * Runs nestedValidate() and returns true if the collection's models (and nested values) are valid.
				 * @param {Object} [options]
				 * @returns {Boolean}
				 */
				isNestedValid: function (options) {
					var self = this,
						methodName = 'isNestedValid',
						ret = typeof self.nestedValidate(options) === 'undefined';

					//DEBUG
					//console.log(self.report(methodName, 'ret = %o'), ret);

					return ret;
				},
				/**
				 * @return {Array} Model objects in this collection which have been changed by the user.
				 */
				whereChanged: function () {
					return _.filter(this.models, function (model) {
						return false !== model.changedAttributes();
					});
				}
			}
		);

		// Make sure that the BaseModel knows about BaseCollection
		BaseModel.prototype._refBaseCollectionClass = BaseCollection;

		return BaseCollection;
	}
);

